<div class="row">
    Procurations Micro-Application is Running...
</div>
